import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
//import Lead from "./Lead";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Calender from "./calander"
import { addClientAppointment, getClientAppointment, deleteClientAppointment, updateClientAppointment} from "../../store/appointment/actions"
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import { isEmpty, map, size } from "lodash";
import axios from "axios"
import Switch from "react-switch"
import { setupInactivityTimer } from "../../helpers/api_helper";
import messageIcon  from "../../assets/img/message-icon.png";
import documentIcon from "../../assets/img/documents-icon.png";
import appIcon from "../../assets/img/appointment-icon.png";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Nav,
  NavItem,
} from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"
import { getClientDetail } from "store/actions";
import TimePicker from "components/Common/Timepicker";
import moment from "moment";
import { API_URL } from "helpers/api_url";
class ClientApp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      modal_standard: false,
      modal_fullscreen: false,
      modal_large: false,
      modal_xlarge: false,
      modal_small: false,
      modal_center: false,
      modal_scroll: false,
      modal_backdrop: false,
      appointment:'',
      appTypes: [],
      appPriories: [],
      appLocTypes: [],
      checked: false

    }
    this.tog_standard = this.tog_standard.bind(this)
    this.tog_fullscreen = this.tog_fullscreen.bind(this)
    this.tog_xlarge = this.tog_xlarge.bind(this)
    this.tog_large = this.tog_large.bind(this)
    this.tog_small = this.tog_small.bind(this)
    this.tog_center = this.tog_center.bind(this)
    this.tog_scroll = this.tog_scroll.bind(this)
    this.tog_backdrop = this.tog_backdrop.bind(this)
    this.handelValidAppointment = this.handelValidAppointment.bind(this)
    this.onClickDelete = this.onClickDelete.bind(this);
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
   
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  onClickDelete = (appointment) => {
    this.setState({ appointment: appointment });
    this.setState({ deleteModal: true });
  };
  handleDeleteAppointment = () => {
    const { onDeleteAppointment } = this.props;
    const { appointment } = this.state;
    
    if (appointment.id !== undefined) {
      onDeleteAppointment(appointment);
      this.setState({ deleteModal: false });
      this.toggle();
    }
  };
  handelValidAppointment(value){
    
    this.props.addClientAppointment(value, this.props.history);

  }
  componentDidMount() {
 
    const { onGetClientApp, onGetClientDetail } = this.props;
    onGetClientApp(localStorage.getItem('agentId'),localStorage.getItem('userId'));
    onGetClientDetail(localStorage.getItem('userId'));
    
}
  tog_standard() {
    this.setState(prevState => ({
      modal_standard: !prevState.modal_standard,
    }))
    this.removeBodyCss()
  }

  removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  tog_fullscreen() {
    this.setState(prevState => ({
      modal_fullscreen: !prevState.modal_fullscreen,
    }))
    this.removeBodyCss()
  }

  tog_backdrop() {
    this.setState(prevState => ({
      modal_backdrop: !prevState.modal_backdrop,
    }))
    this.removeBodyCss()
  }

  tog_large() {
    this.setState(prevState => ({
      modal_large: !prevState.modal_large,
    }))
    this.removeBodyCss()
  }

  tog_xlarge() {
    this.setState(prevState => ({
      modal_xlarge: !prevState.modal_xlarge,
    }))
    this.removeBodyCss()
  }

  tog_small() {
    this.setState(prevState => ({
      modal_small: !prevState.modal_small,
    }))
    this.removeBodyCss()
  }

  tog_center() {
    this.setState(prevState => ({
      modal_center: !prevState.modal_center,
    }))
    this.removeBodyCss()
  }

  tog_scroll() {
    this.setState(prevState => ({
      modal_scroll: !prevState.modal_scroll,
    }))
    this.removeBodyCss()
  }

  show() {
    this.setState({ visible: true })
  }

  hide() {
    this.setState({ visible: false })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { appointments } = this.props;
    if (!isEmpty(appointments) && size(prevProps.appointments) !== size(appointments)) {
      this.setState({ appointments: {}, isEdit: false, changeReject: false });
    }
  }
  toggleRightCanvas() {
    this.setState({ appointment: "", isEdit: false, isRight: !this.state.isRight });
    this.toggle();
  }
  toggleRightCanvas = arg => {
    const appointment = arg;
  
    this.setState({
      appointment: {
    
        id:appointment.id,
        appointmentId: appointment.appointmentId,
        appointmentTitle:appointment.appointmentTitle,
        contactName: appointment.contactName,
        contactPhone: appointment.contactPhone,
        contactEmail: appointment.contactEmail,
        appointmentStartDate: appointment.appointmentStartDate,
        startTime: appointment.startTime,
        endTime: appointment.endTime,
        appointmentType: appointment.appointmentType,
        appointmentStatus: appointment.appointmentStatus,
        appointmentPriority: appointment.appointmentPriority,
        appointmentReminder: appointment.appointmentReminder,
        clientId: appointment.clientId,
        appointmentDescription:appointment.appointmentDescription,
        appointmentLocationType:appointment.appointmentLocationType,
        appointmentLocation:appointment.appointmentLocation,
        locationLatitude:appointment.locationLatitude,
        locationLongitude:appointment.locationLongitude,
        isRepeat:appointment.isRepeat,
        repeatEveryType:appointment.repeatEveryType,
        repeatStep:appointment.repeatStep,
        repeatEndDate:appointment.repeatEndDate,
        agentId:appointment.agentId,
        isActive:appointment.isActive,
        contactNotes: appointment.contactNotes,
        addedBy: appointment.addedBy,
        rejected: appointment.rejected,
      },
      isEdit: true,
    });
    this.toggle();
  };
  handleChange = arg =>  {
    const appointment = arg;
    const { onUpdateStatus } = this.props;
    const updateReg = {
      id:appointment.id,
      appointmentId: appointment.appointmentId,
      rejected: (appointment.rejected==true) ? false : true,
      appointmentTitle:appointment.appointmentTitle,
        contactName: appointment.contactName,
        contactPhone: appointment.contactPhone,
        contactEmail: appointment.contactEmail,
        appointmentStartDate: appointment.appointmentStartDate,
        startTime: appointment.startTime,
        endTime: appointment.endTime,
        appointmentType: appointment.appointmentType,
        appointmentStatus: appointment.appointmentStatus,
        appointmentPriority: appointment.appointmentPriority,
        appointmentReminder: appointment.appointmentReminder,
        clientId: appointment.clientId,
        appointmentDescription:appointment.appointmentDescription,
        appointmentLocationType:appointment.appointmentLocationType,
        appointmentLocation:appointment.appointmentLocation,
        locationLatitude:appointment.locationLatitude,
        locationLongitude:appointment.locationLongitude,
        isRepeat:appointment.isRepeat,
        repeatEveryType:appointment.repeatEveryType,
        repeatStep:appointment.repeatStep,
        repeatEndDate:appointment.repeatEndDate,
        agentId:appointment.agentId,
        isActive:appointment.isActive,
        contactNotes: appointment.contactNotes,
        addedBy: appointment.addedBy
    }

    onUpdateStatus(updateReg);
  };
  render() {
    const { appointments, onUpdateClientAppointment, clientDetail } = this.props;
    
    const now = new Date();
    now.setMinutes(now.getMinutes() + 30);
    const edTime = new Date(now);
    const selectedValue = '';
    const { isEdit, deleteModal } = this.state;
    const appointment = this.state.appointment;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    return (
      <React.Fragment>
         {this.props.loading && this.props.loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
        <ToastContainer autoClose={2000} />
        
         <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteAppointment}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content">
          <MetaTags>
            <title>Client Appointment | Realty Space</title>
          </MetaTags>
          <Container fluid>
             {/* <Breadcrumbs
              title={this.props.t("Appointment")}
              breadcrumbItem={this.props.t("Appointment")}
            /> */}
                 <Row className="justify-content-between align-items-center mb-4">
                <Col sm="12">
                  <Nav tabs className="projectTab pref-tab">
                    <NavItem>
                      <Link className="nav-link " to="/messages">
                        <span className="d-flex align-items-center gap-2">
                          Message
                          <img src={messageIcon} height={16} />
                        </span>
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link className="nav-link " to="/documents">
                        <span className="d-flex align-items-center gap-2">Documents

                           <img src={documentIcon} height={16} />
                        </span>
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link className="nav-link active" to="/appointment">
                         <span className="d-flex align-items-center gap-2">Appointments

                          <img src={appIcon} height={16} />
                         </span>
                      </Link>
                    </NavItem>
                  </Nav>
                </Col>
              </Row>
            <Row>
              
              
              <Col xl="12">
             
		<Row>
				<Col sm="12">
					 <Card className="rs-card-bg"> 
                    <CardBody>
                    <h5 className="card-title text-uppercase mb-4">Appointment History</h5>
					 <div className="">
						  <table className="table mb-0 table">
							<thead>
							  <tr>
								<th>Date/Time</th>
                <th>Type</th>
                <th>Address</th>
								<th>Agenda</th>
								<th>Accept</th>
								
                <th>Action</th>
							  </tr>
							</thead>
							<tbody>
              {map(appointments, (appointment, appoint) => (
                  <tr key={"_app_" + appoint} className={appointment.rejected == false ? 'trreject' : '' } >
                     <td><Moment format="D MMM YY">{appointment.appointmentStartDate}</Moment> - {appointment.startTime} - {appointment.endTime}</td>
                     <td>{localization["AppointmentLocationType_" + appointment.appointmentLocationType]}</td>
                      <td>{appointment.appointmentLocation}</td>
                     <td>{appointment.appointmentTitle}</td>
                  
                    <td>{appointment.addedBy == 'agent' ? 
                 <div style={{ display: "flex", alignItems: "center" }}>
  <Switch
    onChange={(isActive) => this.handleChange(appointment, isActive)}
    checked={!appointment.rejected}
    onColor="#4CAF50"
    offColor="#f39c12"
    height={28}
    width={48}
    handleDiameter={20}
  />
  {/* <span style={{ marginLeft: "10px", fontWeight: "500" }}>
    {!appointment.rejected ? "Accepted" : "Reschedule"}
  </span> */}
</div>
                     : '' }</td>
                    <td>
                    {!appointment.rejected ? 'Accepted' : 
                    <Link
                to={`/messages?m=Request re-schedule for the meeting set for ${moment(appointment.appointmentStartDate).format("MMM DD")} at ${appointment.startTime}`}
                className="btn btn-primary btn-sm"
              >Send message</Link>}
                  
                 
                    
                    </td>
                  </tr>            
               ))}
							  
							</tbody>
						  </table>

            
						</div> 
					</CardBody>
					</Card>
				</Col>
			</Row>
    
            </Col>
            
            </Row>
           
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientApp.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  addClientAppointment:PropTypes.func,
  onGetClientApp:PropTypes.func,
  appointments:PropTypes.array,
  onDeleteAppointment:PropTypes.func,
  onUpdateClientAppointment: PropTypes.func,
  loading:PropTypes.object,
  onRejectedChange:PropTypes.func,
  onUpdateStatus:PropTypes.func,
  onGetClientDetail:PropTypes.func,
  clientDetail:PropTypes.object,


}
const mapStateToProps = ({ Appointments, Profile }) => (
  {
    clientDetail: Profile.clientDetail,
    appointments:Appointments.appointments,
    loading:Appointments.loading

  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  addClientAppointment: (data) => dispatch(addClientAppointment(data)),
  onGetClientApp:(agentId,clientId) => dispatch(getClientAppointment(agentId,clientId)),
  onDeleteAppointment:(id) => dispatch(deleteClientAppointment(id)),
  onUpdateClientAppointment: (data, callback) => dispatch(updateClientAppointment(data, callback)),
  onUpdateStatus:(data) =>  dispatch(updateClientAppointment(data)),
  
 
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientApp))
